<template>
  <div class="box">
    <Echart
      id="rightTopChart"
      :options="options"
      height="320px"
      width="450px"
    ></Echart>
  </div>
</template>

<script>
import Echart from "@/common/echart";
export default {
  data() {
    return {
      number: 0,
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    cdata: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    cdata: {
      handler(newData) {
        this.options = {
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/> {b}: {c} ({d}%)"
          },
          legend: {
            orient: "vertical",
            right: "right"
          },
          series: [
            {
              name: "任务状态统计",
              type: "pie",
              radius: [" 40%", "60%"],
              center: ["40%", "35%"],
              // data: this.mainData,
              data: [
                { name: "正常", order: 0, total: null, value: 0 },
                { name: "禁用", order: 0, total: null, value: 0 },
                { name: "失效", order: 0, total: null, value: 0 }
              ],
              label: {
                normal: {
                  show: true,
                  position: "outer",
                  //模板变量有 {a}, {b}，{c}，{d}，{e}，分别表示系列名，数据名，数据值等。
                  formatter: "{d}%",
                  borderWidth: 20,
                  borderRadius: 4,
                  padding: 10,
                  rich: {
                    a_set: {
                      color: "#1a1a1a",
                      lineHeight: 20,
                      align: "center"
                    },
                    c_set: {
                      color: "#808080"
                    }
                  }
                },
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)"
                  }
                }
              }
            }
          ]
        };
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.$nextTick(() => {
      // this.getEcharts();
    });
  },
  methods: {
    async getEcharts() {
      let _this = this;
      const { success, data } = await _this.Api.getAnyTaskStatus();
      if (success) {
        console.log("任务状态:", data.data);
        this.mainData = data.data;
      }
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scope>
.box {
  width: 100%;
  height: 100%;
  margin-top: 10px;
  margin-left: 50px;
  .tit {
    float: left;
    margin-top: 18px;
    font-size: 28px;
  }
  .title {
    float: right;
    margin-top: -40px;
    margin-right: 56px;
    font-size: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/screen/components/rightTopChart/index.vue